/**
 * Extrae ítems de nivel 4 del plan de cuentas jerárquico.
 * Agrupa por nivel 1 y 2, agregando encabezados de sección.
 */
export function extractLevel4Items(data) {
  const level4Items = [];

  const processItem = (item, level = 1, level1Item = null, level2Item = null) => {
    if (level === 1) {
      if (item.children && item.children.length > 0) {
        item.children.forEach((child) => {
          processItem(child, level + 1, item, null);
        });
      }
    } else if (level === 2) {
      if (item.children && item.children.length > 0) {
        item.children.forEach((child) => {
          processItem(child, level + 1, level1Item, item);
        });
      }
    } else if (level === 3) {
      if (item.children && item.children.length > 0) {
        item.children.forEach((child) => {
          processItem(child, level + 1, level1Item, level2Item);
        });
      }
    } else if (level === 4) {
      const displayText = `${item.key} ${item.name}`;
      const sectionKey = `${level1Item?.key || ""}-${level2Item?.key || ""}`;
      const lastItem = level4Items[level4Items.length - 1];
      const lastSectionKey = lastItem?.sectionKey;

      if (sectionKey !== lastSectionKey && level1Item && level2Item) {
        const sectionTitle = `${level1Item.name} > ${level2Item.label}`;
        level4Items.push({
          key: `section-${sectionKey}`,
          value: null,
          text: sectionTitle,
          isSection: true,
          sectionKey,
          level1Key: level1Item.key,
          level2Key: level2Item.key,
        });
      }

      level4Items.push({
        key: item.key,
        value: item.key,
        text: displayText,
        label: item.name,
        account: item,
        sectionKey,
        level1Key: level1Item?.key,
        level2Key: level2Item?.key,
      });
    }
  };

  (data || []).forEach((item) => {
    processItem(item, 1);
  });

  return level4Items;
}

export function findSelectablePlanDeCuentaOption(options, value) {
  return (options || []).find((opt) => !opt.isSection && opt.value === value);
}
